import React from 'react'

const Header = () => {
  return (
    <header>
      <img className="logo" src='./logo.svg' alt="logo" width="144" />
    </header>
  )
}

export default Header